/**
 * @file scheduleOverride.js
 *
 * Schedule Override API Service
 *
 * API calls to /api/v1/schedule-override.
 * Manages per-date exceptions (blocked days, special hours).
 */
import api from "./api";

export const scheduleOverrideService = {
  /** Get all schedule overrides for the logged-in professional. */
  getMe: () => api.get("/schedule-override/me"),
  /** Create a new schedule override (blocked day or special hours). */
  create: (data) => api.post("/schedule-override/create", data),
  /** Update an existing schedule override. */
  update: (id, data) => api.put(`/schedule-override/${id}`, data),
  /** Delete a schedule override. */
  remove: (id) => api.delete(`/schedule-override/${id}`),
};
